import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_TIME_ENTRIES = 'GET_TIME_ENTRIES';
export const GET_TIME_ENTRY = 'GET_TIME_ENTRY';
export const CREATE_TIME_ENTRY = 'CREATE_TIME_ENTRY';
export const UPDATE_TIME_ENTRY = 'UPDATE_TIME_ENTRY';
export const DELETE_TIME_ENTRY = 'DELETE_TIME_ENTRY';
export const APPROVE_TIME_ENTRY = 'APPROVE_TIME_ENTRY';
export const START_TIMER = 'START_TIMER';
export const STOP_TIMER = 'STOP_TIMER';

// Get time entries
export const getTimeEntries = (filters) => async (dispatch) => {
  try {
    const { data } = await api.fetchTimeEntries(filters);

    dispatch({
      type: GET_TIME_ENTRIES,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching time entries:', error);
    throw error;
  }
};

// Get single time entry
export const getTimeEntry = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchTimeEntry(id);

    dispatch({
      type: GET_TIME_ENTRY,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching time entry:', error);
    throw error;
  }
};

// Create time entry
export const createTimeEntry = (timeData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.createTimeEntry(timeData);

    dispatch({
      type: CREATE_TIME_ENTRY,
      payload: data
    });

    openSnackbar('Time entry created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Time entry created successfully"));

    return data;
  } catch (error) {
    console.error('Error creating time entry:', error);
    openSnackbar('Error creating time entry', SNACKBAR_DURATION_MS, getSnackbarColor("Error creating time entry"));
    throw error;
  }
};

// Update time entry
export const updateTimeEntry = (id, timeData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateTimeEntry(id, timeData);

    dispatch({
      type: UPDATE_TIME_ENTRY,
      payload: data
    });

    openSnackbar('Time entry updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Time entry updated successfully"));

    return data;
  } catch (error) {
    console.error('Error updating time entry:', error);
    openSnackbar('Error updating time entry', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating time entry"));
    throw error;
  }
};

// Delete time entry
export const deleteTimeEntry = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteTimeEntry(id);

    dispatch({
      type: DELETE_TIME_ENTRY,
      payload: id
    });

    openSnackbar('Time entry deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Time entry deleted successfully"));
  } catch (error) {
    console.error('Error deleting time entry:', error);
    openSnackbar('Error deleting time entry', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting time entry"));
    throw error;
  }
};

// Approve time entry
export const approveTimeEntry = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.approveTimeEntry(id);

    dispatch({
      type: APPROVE_TIME_ENTRY,
      payload: data
    });

    openSnackbar('Time entry approved successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Time entry approved successfully"));

    return data;
  } catch (error) {
    console.error('Error approving time entry:', error);
    openSnackbar('Error approving time entry', SNACKBAR_DURATION_MS, getSnackbarColor("Error approving time entry"));
    throw error;
  }
};

// Start timer
export const startTimer = (caseId, activityType) => async (dispatch) => {
  try {
    const { data } = await api.startTimer({ caseId, activityType });

    dispatch({
      type: START_TIMER,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error starting timer:', error);
    throw error;
  }
};

// Stop timer
export const stopTimer = (timerId, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.stopTimer(timerId);

    dispatch({
      type: STOP_TIMER,
      payload: data
    });

    openSnackbar('Timer stopped and time entry created', SNACKBAR_DURATION_MS, getSnackbarColor("Timer stopped and time entry created"));

    return data;
  } catch (error) {
    console.error('Error stopping timer:', error);
    openSnackbar('Error stopping timer', SNACKBAR_DURATION_MS, getSnackbarColor("Error stopping timer"));
    throw error;
  }
};
